exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dropdown-select{font-size:16px;line-height:24px;font-weight:inherit;width:100%;display:flex;flex-direction:column;position:relative}.dropdown-select__options-container{z-index:4;background-color:#e9ebec;position:absolute;border-radius:.25rem}.dropdown-select--small{font-size:14px}.dropdown-select__options-container--align-right{right:0}.dropdown-select__options-container--align-left{left:0}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};